/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Status_OpenInputs */

const en_settings_tickets_status_open = /** @type {(inputs: Settings_Tickets_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const zh_settings_tickets_status_open = /** @type {(inputs: Settings_Tickets_Status_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待处理`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Settings_Tickets_Status_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_status_open = /** @type {((inputs?: Settings_Tickets_Status_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Status_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_status_open(inputs)
	return zh_settings_tickets_status_open(inputs)
});
export { settings_tickets_status_open as "settings.tickets.status_open" }